import React from 'react';
import { SafeHtml } from '../../utils/sanitizeHtml';

export default function EmailMessageBubble({ message, onReply }) {
  const isOutbound = message.direction === 'outbound';
  // toDisplay: handle array or string
  const toDisplay = Array.isArray(message.to)
    ? message.to.join(', ')
    : message.to;
  const rawBody = message.html || message.text || '';
  const timestamp = message.timestamp || message.occurredAt;

  return (
    <div
      className={`relative max-w-[70%] p-4 rounded-[16px] shadow-[0_1px_4px_rgba(0,0,0,0.05)] ${
        isOutbound ? 'ml-auto bg-[#DBEAFE]' : 'mr-auto bg-[#E5E7EB]'
      }`}
    >
      {/* Header row: From/To + optional Reply */}
      <div className="flex justify-between items-center mb-1">
        <p className="text-xs font-medium text-[#6B7280]">
          {isOutbound ? `To: ${toDisplay}` : `From: ${message.from}`}
        </p>
        {!isOutbound && onReply && (
          <button
            className="text-xs text-[#2563EB] hover:underline"
            onClick={() => onReply({ threadId: message.threadId, from: message.from })}
          >
            Reply
          </button>
        )}
      </div>

      {/* Message body — HTML is sanitized via DOMPurify to prevent XSS and
          plain-text fallbacks get newlines preserved via the helper. */}
      <SafeHtml
        value={rawBody}
        className="text-sm text-[#1F2937] mb-1 prose prose-sm max-w-none prose-a:text-indigo-600 prose-p:my-1.5"
      />

      {/* Timestamp */}
      <p className="text-[10px] text-[#9CA3AF] text-right">
        {timestamp ? new Date(timestamp).toLocaleString() : '—'}
      </p>
    </div>
  );
}
